export default __webpack_public_path__ + "static/media/BCA33.9077b8c7.jpg";